<!-- Hero Section -->
<div class="hero-section">
  <nav class="navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm">
    <div class="container">
      <a class="navbar-brand d-flex align-items-center gap-2" href="#">
        <img src="assets/logo-clinixcore.svg" alt="ClinixCore" height="40">
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto align-items-center">
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToSection('features')" style="cursor: pointer;">Funcionalidades</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToSection('pricing')" style="cursor: pointer;">Preços</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToSection('testimonials')" style="cursor: pointer;">Depoimentos</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="scrollToSection('faq')" style="cursor: pointer;">FAQ</a>
          </li>
          <li class="nav-item">
            <button class="btn btn-outline-primary ms-3" (click)="goToLogin()">
              <i class="bi bi-box-arrow-in-right me-1"></i> Entrar
            </button>
          </li>
          <li class="nav-item">
            <button class="btn btn-primary ms-2" (click)="startTrial()">
              Teste Grátis
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="container hero-content">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="hero-badge mb-3">
          <span class="badge bg-primary-soft text-primary px-3 py-2">
            <i class="bi bi-star-fill me-1"></i> Plataforma #1 em Gestão Clínica
          </span>
        </div>
        <h1 class="display-3 fw-bold mb-4">
          O Núcleo da sua <span class="text-gradient">Prática Clínica</span>
        </h1>
        <p class="lead mb-4 text-muted">
          Sistema completo de gestão para profissionais de saúde. Agenda inteligente,
          prontuário eletrônico, controle financeiro e muito mais — tudo em um só lugar.
        </p>
        <div class="d-flex gap-3 mb-4 flex-wrap">
          <button class="btn btn-primary btn-lg shadow-sm" (click)="startTrial()">
            <i class="bi bi-rocket-takeoff me-2"></i>
            Começar Teste Grátis
          </button>
          <button class="btn btn-outline-secondary btn-lg" (click)="scrollToSection('features')">
            <i class="bi bi-play-circle me-2"></i>
            Ver Funcionalidades
          </button>
        </div>
        <div class="hero-trust d-flex gap-4 flex-wrap">
          <div class="trust-item">
            <i class="bi bi-check-circle-fill text-success me-2"></i>
            <span class="text-muted">30 dias grátis</span>
          </div>
          <div class="trust-item">
            <i class="bi bi-check-circle-fill text-success me-2"></i>
            <span class="text-muted">Sem cartão</span>
          </div>
          <div class="trust-item">
            <i class="bi bi-check-circle-fill text-success me-2"></i>
            <span class="text-muted">Cancele quando quiser</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mt-5 mt-lg-0">
        <div class="hero-image position-relative">
          <!-- Elementos decorativos -->
          <div class="hero-blob hero-blob-1"></div>
          <div class="hero-blob hero-blob-2"></div>

          <div class="mockup-card shadow-lg">
            <div class="mockup-header">
              <div class="mockup-dots">
                <span class="dot-red"></span>
                <span class="dot-yellow"></span>
                <span class="dot-green"></span>
              </div>
              <div class="mockup-title">Dashboard Clínico</div>
            </div>
            <div class="mockup-content">
              <div class="stats-preview">
                <div class="stat-card">
                  <div class="stat-icon bg-primary-soft">
                    <i class="bi bi-calendar-check text-primary"></i>
                  </div>
                  <div class="stat-value">127</div>
                  <div class="stat-label">Consultas/Mês</div>
                </div>
                <div class="stat-card">
                  <div class="stat-icon bg-success-soft">
                    <i class="bi bi-currency-dollar text-success"></i>
                  </div>
                  <div class="stat-value">R$ 12.450</div>
                  <div class="stat-label">Receita</div>
                </div>
                <div class="stat-card">
                  <div class="stat-icon bg-info-soft">
                    <i class="bi bi-graph-up-arrow text-info"></i>
                  </div>
                  <div class="stat-value">98%</div>
                  <div class="stat-label">Confirmadas</div>
                </div>
              </div>

              <!-- Mini Calendar Preview -->
              <div class="calendar-mini mt-3">
                <div class="calendar-header">
                  <small class="text-muted fw-semibold">Próximos Atendimentos</small>
                </div>
                <div class="appointment-item">
                  <div class="appointment-time">09:00</div>
                  <div class="appointment-info">
                    <div class="appointment-name">Maria Silva</div>
                    <div class="appointment-type">Consulta • Telemedicina</div>
                  </div>
                  <span class="badge bg-success-soft text-success">Confirmado</span>
                </div>
                <div class="appointment-item">
                  <div class="appointment-time">11:30</div>
                  <div class="appointment-info">
                    <div class="appointment-name">João Santos</div>
                    <div class="appointment-type">Retorno • Presencial</div>
                  </div>
                  <span class="badge bg-warning-soft text-warning">Pendente</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Features Section -->
<section id="features" class="features-section py-5">
  <div class="container">
    <div class="text-center mb-5">
      <span class="badge bg-primary-soft text-primary px-3 py-2 mb-3">
        Funcionalidades
      </span>
      <h2 class="display-5 fw-bold mb-3">Tudo que você precisa em um só lugar</h2>
      <p class="lead text-muted">Recursos pensados para otimizar sua rotina profissional</p>
    </div>

    <div class="row g-4">
      <div class="col-md-6 col-lg-4" *ngFor="let feature of features">
        <div class="feature-card h-100 shadow-sm">
          <div class="feature-icon-wrapper">
            <div class="feature-icon">{{ feature.icon }}</div>
          </div>
          <h4 class="mb-3 fw-semibold">{{ feature.title }}</h4>
          <p class="text-muted mb-0">{{ feature.description }}</p>
        </div>
      </div>
    </div>

    <!-- Integrations Banner -->
    <div class="integrations-banner mt-5 p-4 rounded-3 bg-light">
      <div class="row align-items-center">
        <div class="col-lg-8">
          <h5 class="fw-bold mb-2">
            <i class="bi bi-plug text-primary me-2"></i>
            Integrações Poderosas
          </h5>
          <p class="text-muted mb-0">
            Google Calendar • WhatsApp • Stripe • Banco do Brasil • E muito mais...
          </p>
        </div>
        <div class="col-lg-4 text-lg-end mt-3 mt-lg-0">
          <button class="btn btn-primary" (click)="scrollToSection('pricing')">
            Ver Todos os Recursos
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Pricing Section -->
<section id="pricing" class="pricing-section py-5 bg-light">
  <div class="container">
    <div class="text-center mb-5">
      <span class="badge bg-success-soft text-success px-3 py-2 mb-3">
        Preços
      </span>
      <h2 class="display-5 fw-bold mb-3">Plano Simples e Transparente</h2>
      <p class="lead text-muted">Sem taxas ocultas. Cancele quando quiser.</p>
    </div>

    <div class="row justify-content-center">
      <div class="col-lg-5" *ngFor="let plan of plans">
        <div class="pricing-card shadow-lg" [class.featured]="plan.highlight">
          <div class="pricing-badge" *ngIf="plan.highlight">
            <i class="bi bi-star-fill me-1"></i> Mais Popular
          </div>
          <div class="pricing-header text-center mb-4">
            <div class="pricing-icon mb-3">
              <i class="bi bi-heart-pulse-fill"></i>
            </div>
            <h3 class="fw-bold mb-2">{{ plan.name }}</h3>
            <p class="text-muted mb-0">Para profissionais de saúde</p>
          </div>

          <div class="price-tag text-center mb-4">
            <div class="d-flex align-items-start justify-content-center">
              <span class="currency">R$</span>
              <span class="amount">{{ plan.price }}</span>
            </div>
            <span class="period">{{ plan.period }}</span>
            <p class="text-muted mt-2 mb-0">por profissional</p>
          </div>

          <ul class="features-list mb-4">
            <li *ngFor="let feature of plan.features">
              <i class="bi bi-check-circle-fill text-success"></i>
              {{ feature }}
            </li>
          </ul>

          <button class="btn btn-primary btn-lg w-100 shadow-sm" (click)="startTrial()">
            <i class="bi bi-rocket-takeoff me-2"></i>
            Começar Teste Grátis
          </button>

          <div class="text-center mt-3">
            <p class="text-muted small mb-0">
              <i class="bi bi-shield-check text-success me-1"></i>
              30 dias grátis • Sem compromisso
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-5">
      <div class="payment-methods p-4 bg-white rounded-3 shadow-sm">
        <p class="text-muted mb-3 fw-semibold">
          <i class="bi bi-credit-card me-2"></i>
          Formas de Pagamento Aceitas
        </p>
        <div class="d-flex gap-3 justify-content-center flex-wrap">
          <span class="badge bg-light text-dark border px-3 py-2">💳 Cartão de Crédito</span>
          <span class="badge bg-light text-dark border px-3 py-2">💳 Cartão de Débito</span>
          <span class="badge bg-light text-dark border px-3 py-2">💰 PIX</span>
          <span class="badge bg-light text-dark border px-3 py-2">📄 Boleto</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Testimonials Section -->
<section id="testimonials" class="testimonials-section py-5">
  <div class="container">
    <div class="text-center mb-5">
      <span class="badge bg-warning-soft text-warning px-3 py-2 mb-3">
        Depoimentos
      </span>
      <h2 class="display-5 fw-bold mb-3">O que nossos clientes dizem</h2>
      <p class="lead text-muted">Profissionais que já transformaram sua gestão</p>
    </div>

    <div class="row g-4">
      <div class="col-lg-4" *ngFor="let testimonial of testimonials">
        <div class="testimonial-card h-100 shadow-sm">
          <div class="testimonial-rating mb-3">
            <i class="bi bi-star-fill text-warning"></i>
            <i class="bi bi-star-fill text-warning"></i>
            <i class="bi bi-star-fill text-warning"></i>
            <i class="bi bi-star-fill text-warning"></i>
            <i class="bi bi-star-fill text-warning"></i>
          </div>
          <p class="testimonial-text">"{{ testimonial.text }}"</p>
          <div class="testimonial-author d-flex align-items-center gap-3 mt-4">
            <div class="testimonial-photo">{{ testimonial.photo }}</div>
            <div>
              <strong class="d-block">{{ testimonial.name }}</strong>
              <small class="text-muted">{{ testimonial.specialty }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- FAQ Section -->
<section id="faq" class="faq-section py-5 bg-light">
  <div class="container">
    <div class="text-center mb-5">
      <span class="badge bg-info-soft text-info px-3 py-2 mb-3">
        FAQ
      </span>
      <h2 class="display-5 fw-bold mb-3">Perguntas Frequentes</h2>
      <p class="lead text-muted">Tire suas dúvidas sobre a ClinixCore</p>
    </div>

    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="faq-accordion">
          <div class="faq-item" *ngFor="let faq of faqs; let i = index">
            <div class="faq-question" (click)="toggleFaq(i)">
              <h5 class="mb-0 fw-semibold">{{ faq.question }}</h5>
              <i class="bi fs-5" [class.bi-chevron-down]="!faq.open" [class.bi-chevron-up]="faq.open"></i>
            </div>
            <div class="faq-answer" [class.show]="faq.open">
              <p class="text-muted mb-0">{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section py-5">
  <div class="container">
    <div class="cta-card text-center p-5 rounded-4 shadow-lg">
      <div class="cta-icon mb-4">
        <img src="assets/icon-clinixcore-light.svg" alt="ClinixCore" height="80">
      </div>
      <h2 class="display-5 fw-bold mb-3 text-white">
        Pronto para transformar sua gestão clínica?
      </h2>
      <p class="lead text-white-50 mb-4">
        Junte-se a centenas de profissionais que já otimizaram sua rotina com a ClinixCore
      </p>
      <div class="d-flex gap-3 justify-content-center flex-wrap">
        <button class="btn btn-light btn-lg px-5 shadow" (click)="startTrial()">
          <i class="bi bi-rocket-takeoff me-2"></i>
          Começar Agora - É Grátis
        </button>
        <button class="btn btn-outline-light btn-lg px-5" (click)="goToLogin()">
          <i class="bi bi-box-arrow-in-right me-2"></i>
          Já tenho conta
        </button>
      </div>
      <p class="text-white-50 mt-4 mb-0">
        <i class="bi bi-shield-check me-1"></i>
        30 dias grátis • Sem cartão de crédito • Cancele quando quiser
      </p>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="footer py-5 bg-dark text-white">
  <div class="container">
    <div class="row g-4">
      <div class="col-lg-4">
        <img src="assets/logo-clinixcore-light.svg" alt="ClinixCore" height="40" class="mb-3">
        <p class="text-white-50 mb-3">
          O núcleo da sua prática clínica. Sistema completo de gestão para
          profissionais de saúde e bem-estar.
        </p>
        <div class="social-links d-flex gap-2">
          <a href="#" class="btn btn-outline-light btn-sm">
            <i class="bi bi-facebook"></i>
          </a>
          <a href="#" class="btn btn-outline-light btn-sm">
            <i class="bi bi-instagram"></i>
          </a>
          <a href="#" class="btn btn-outline-light btn-sm">
            <i class="bi bi-linkedin"></i>
          </a>
          <a href="#" class="btn btn-outline-light btn-sm">
            <i class="bi bi-youtube"></i>
          </a>
        </div>
      </div>

      <div class="col-lg-2 col-md-4">
        <h6 class="fw-bold mb-3">Produto</h6>
        <ul class="list-unstyled">
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Funcionalidades</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Preços</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Integrações</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Atualizações</a>
          </li>
        </ul>
      </div>

      <div class="col-lg-2 col-md-4">
        <h6 class="fw-bold mb-3">Empresa</h6>
        <ul class="list-unstyled">
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Sobre Nós</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Blog</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Carreiras</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Contato</a>
          </li>
        </ul>
      </div>

      <div class="col-lg-2 col-md-4">
        <h6 class="fw-bold mb-3">Legal</h6>
        <ul class="list-unstyled">
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Termos de Uso</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Privacidade</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">LGPD</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Segurança</a>
          </li>
        </ul>
      </div>

      <div class="col-lg-2 col-md-4">
        <h6 class="fw-bold mb-3">Suporte</h6>
        <ul class="list-unstyled">
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Central de Ajuda</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Documentação</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Status</a>
          </li>
          <li class="mb-2">
            <a href="#" class="text-white-50 text-decoration-none">Fale Conosco</a>
          </li>
        </ul>
      </div>
    </div>

    <hr class="my-4 border-secondary">

    <div class="row align-items-center">
      <div class="col-md-6">
        <p class="text-white-50 mb-0 small">
          © 2026 ClinixCore. Todos os direitos reservados.
        </p>
      </div>
      <div class="col-md-6 text-md-end">
        <p class="text-white-50 mb-0 small">
          <i class="bi bi-shield-check me-1"></i>
          Dados protegidos e criptografados
        </p>
      </div>
    </div>
  </div>
</footer>
